var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUpgradeProfileBenefits1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1553_7678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.90198 10.2084V15.3125H8.7059",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6078 32.0834L16.6862 32.0834L16.6862 26.25",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3922 32.0834L21.0393 32.0834L21.0393 26.25",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.098 23.3334L34.098 18.9584L28.2941 18.9584",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90198 23.3334V18.9584H8.7059",
    stroke: "#6CA5D4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.098 10.2084L34.098 15.3125L28.2941 15.3125",
    stroke: "#89B59F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80392 9.47917C4.80392 10.5425 3.94763 11.3958 2.90196 11.3958C1.8563 11.3958 1 10.5425 1 9.47917C1 8.41585 1.8563 7.5625 2.90196 7.5625C3.94763 7.5625 4.80392 8.41585 4.80392 9.47917Z",
    fill: "#DFE9E3",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 9.47917C36 10.5425 35.1437 11.3958 34.098 11.3958C33.0523 11.3958 32.196 10.5425 32.196 9.47917C32.196 8.41585 33.0523 7.5625 34.098 7.5625C35.1437 7.5625 36 8.41585 36 9.47917Z",
    fill: "#89B59F",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80392 24.0625C4.80392 25.1259 3.94763 25.9792 2.90196 25.9792C1.8563 25.9792 1 25.1259 1 24.0625C1 22.9992 1.8563 22.1459 2.90196 22.1459C3.94763 22.1459 4.80392 22.9992 4.80392 24.0625Z",
    fill: "#6CA5D4",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 24.0625C36 25.1259 35.1437 25.9792 34.098 25.9792C33.0523 25.9792 32.196 25.1259 32.196 24.0625C32.196 22.9992 33.0523 22.1459 34.098 22.1459C35.1437 22.1459 36 22.9992 36 24.0625Z",
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0196 32.0833C28.0196 33.1466 27.1633 34 26.1177 34C25.072 34 24.2157 33.1466 24.2157 32.0833C24.2157 31.02 25.072 30.1666 26.1177 30.1666C27.1633 30.1666 28.0196 31.02 28.0196 32.0833Z",
    fill: "#413D45",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7843 32.0833C12.7843 33.1466 11.928 34 10.8823 34C9.83664 34 8.98035 33.1466 8.98035 32.0833C8.98035 31.02 9.83664 30.1666 10.8823 30.1666C11.928 30.1666 12.7843 31.02 12.7843 32.0833Z",
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4902 9.74996C23.0424 9.74996 23.4902 9.30224 23.4902 8.74996C23.4902 8.19767 23.0424 7.74996 22.4902 7.74996V9.74996ZM14.5098 8.74996H13.5098C13.5098 9.30224 13.9575 9.74996 14.5098 9.74996V8.74996ZM21.4902 5.10413C21.4902 5.65641 21.9379 6.10413 22.4902 6.10413C23.0424 6.10413 23.4902 5.65641 23.4902 5.10413H21.4902ZM22.4902 7.74996H14.5098V9.74996H22.4902V7.74996ZM15.5098 8.74996V4.71932H13.5098V8.74996H15.5098ZM21.4902 4.73954V5.10413H23.4902V4.73954H21.4902ZM18.5 1.72913C20.1448 1.72913 21.4902 3.08151 21.4902 4.73954H23.4902C23.4902 1.99012 21.2625 -0.270874 18.5 -0.270874V1.72913ZM18.5 -0.270874C15.744 -0.270874 13.5098 1.96332 13.5098 4.71932H15.5098C15.5098 3.06788 16.8485 1.72913 18.5 1.72913V-0.270874Z",
    fill: "#413D45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.4314,
    y: 8.75,
    width: 18.1373,
    height: 16.7708,
    rx: 4,
    fill: "#C7DFF2",
    stroke: "#413D45",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5882 17.1355C20.0288 16.8029 20.3137 16.2734 20.3137 15.677C20.3137 14.6703 19.5017 13.8541 18.5 13.8541C17.4983 13.8541 16.6863 14.6703 16.6863 15.677C16.6863 16.2734 16.9712 16.8029 17.4118 17.1355V19.3284C17.4118 19.9294 17.899 20.4166 18.5 20.4166C19.101 20.4166 19.5882 19.9294 19.5882 19.3284V17.1355Z",
    fill: "#413D45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1553_7678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpgradeProfileBenefits1);
export default __webpack_public_path__ + "static/media/icon-upgrade-profile-benefits-1.2e478ab103fc3cd060f173652ab8c6a4.svg";
export { ForwardRef as ReactComponent };